import Vue from 'vue';
import VueAmplitude from 'vue-amplitude-js';

Vue.use(VueAmplitude, { apiKey: process.env.VUE_APP_AMPLITUDE_API });
